import { router } from '../utils/router';
export function homeRoute() {
    return ['/', undefined, { shallow: true }];
}
export function homeRouting() {
    router.push(null, homeRoute);
}
